import styled from 'styled-components'
import { GREY_DARK, WHITE } from '../../utils/colors'
import { SM } from '../../utils/screenSizes'

export const Container = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding: 16px;
  z-index: 1000;

  .modal_background {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0.3;
    background: black;
  }

  .modal_content {
    position: relative;
    max-height: 90%;
    overflow: auto;
    z-index: 2;
    padding: 49px;
    border-radius: 8px;
    width: 100%;
    max-width: 610px;
    border: 1px solid #E7E7E7;
    background: ${WHITE};

    @media (max-width: ${SM}) {
      padding: 16px;
    }

    .modal_close {
      cursor: pointer;
      position: absolute;
      top: 25px;
      right: 25px;
      background: transparent;
      border: none;
    }

    .modal_title {
      font-family: inherit;
      font-weight: 700;
      font-size: 24px;
      line-height: 32px;
      margin-right: 50px;
    }

    .modal_content_info {
      min-height: 60px;
      margin-top: 23px;
      margin-bottom: 23px;
      font-size: 18px;
      line-height: 26px;
      color: ${GREY_DARK};
    }
  }
`
